// src/pages/LandingPage.jsx
import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';
import HowItWorksSection from '../components/HowItWorksSection';
import FAQSection from '../components/FAQSection';

const LandingPage = () => {
    return (
        <div>
            {/* Pasa los IDs como props al Header si el Header está fuera de esta página y necesita conocerlos, 
                o si el Header maneja el active link. Para un simple scroll a ancla, no es estrictamente necesario. */}
            <Header />

            {/* HeroSection no necesita ID para el menú generalmente, pero podría tener uno para otros propósitos */}
            <div id="hero-section"> {/* Puedes añadir un ID aquí si también quieres un link al inicio */}
                <HeroSection />
            </div>

            {/* El atributo id se añade directamente al componente de sección o a un div que lo envuelva */}
            <div id="features-section">
                <FeaturesSection />
            </div>

            <div id="how-it-works-section">
                <HowItWorksSection />
            </div>

            <div id="testimonials-section">
                <TestimonialsSection />
            </div>

            <div id="faq-section">
                <FAQSection />
            </div>

            <CallToAction />
            <Footer />
        </div>
    );
};

export default LandingPage;